/* Akoya – duenne Scroll-Fortschritts-Linie am linken Rand.
   Absichtlich nur auf Desktop/Tablet (siehe CSS).

   Wichtig: Je nach Browser/Geraet scrollt entweder das Fenster selbst
   oder ein innerer Container (.page-wrapper, wegen aktivierter
   Seitenuebergaenge). Statt ein festes Element anzunehmen, ermitteln
   wir bei jedem Update, welches Element gerade tatsaechlich den
   groessten Scroll-Bereich hat – funktioniert so browserunabhaengig. */

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  var line = document.createElement('div');
  line.className = 'akoya-scroll-progress';
  line.setAttribute('aria-hidden', 'true');
  document.body.appendChild(line);

  var ticking = false;

  function getScrollMetrics() {
    var candidates = [
      document.querySelector('.page-wrapper'),
      document.scrollingElement,
      document.documentElement
    ];
    var best = null;
    var bestRange = 0;

    candidates.forEach(function (el) {
      if (!el) return;
      var range = el.scrollHeight - el.clientHeight;
      if (range > bestRange) {
        best = el;
        bestRange = range;
      }
    });

    if (!best) return { scrollTop: window.scrollY || 0, scrollHeight: 0 };
    return { scrollTop: best.scrollTop, scrollHeight: bestRange };
  }

  function update() {
    var metrics = getScrollMetrics();
    var progress = metrics.scrollHeight > 0 ? metrics.scrollTop / metrics.scrollHeight : 0;
    progress = Math.max(0, Math.min(1, progress));
    line.style.transform = 'scaleY(' + progress.toFixed(3) + ')';
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  update();
})();
